import { render, staticRenderFns } from "./OverviewOrderView.vue?vue&type=template&id=7c64cd43&scoped=true&"
import script from "./OverviewOrderView.vue?vue&type=script&lang=js&"
export * from "./OverviewOrderView.vue?vue&type=script&lang=js&"
import style0 from "./OverviewOrderView.vue?vue&type=style&index=0&id=7c64cd43&prod&lang=css&"
import style1 from "./OverviewOrderView.vue?vue&type=style&index=1&id=7c64cd43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64cd43",
  null
  
)

export default component.exports